import { fetchFromApi } from '../../helpers/api';

export const JobTypesActionTypes = {
  GET_JOB_TYPES_REQUEST: 'JOB_TYPES/GET_JOB_TYPES_REQUEST',
  GET_JOB_TYPES_SUCCESS: 'JOB_TYPES/GET_JOB_TYPES_SUCCESS',
  GET_JOB_TYPES_FAILURE: 'JOB_TYPES/GET_JOB_TYPES_FAILURE'
};

export const getJobTypes = () => {
  const headers = new Headers();

  const init = {
    method: 'GET',
    headers
  };

  return {
    types: [
      JobTypesActionTypes.GET_JOB_TYPES_REQUEST,
      JobTypesActionTypes.GET_JOB_TYPES_SUCCESS,
      JobTypesActionTypes.GET_JOB_TYPES_FAILURE
    ],
    shouldCallApi: state => state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi('job_types/', init, dispatch)
  };
};



/** WEBPACK FOOTER **
 ** ./src/state/job_types/actions.js
 **/